import React, { useState, useRef, useEffect } from 'react';
// import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import axios from 'axios';
import styles from './index.module.scss';

const Slider = (props) => {
  const {
    item,
    step,
    min,
    max,
    value,
    defaultLength,
    onChangeValue,
    linearGradientColor,
    rangeBackgroundColor,
    sync,
  } = props;

  const rangeRef = useRef();
  const [range, setRange] = useState(defaultLength);
  const [inputValue, setInputValue] = useState(value || 0);

  useEffect(() => {
    if (sync === 1) {
      const rangeValue = parseInt(rangeRef.current.value, 0);
      rangeLinearGradient(rangeValue, min, max);
      // socket回call同步數值
      setRange(value);
      setInputValue(value);
      rangeLinearGradient(value, min, max);
    }
  }, [rangeRef, min, max, value]);

  const handleChange = (max) => (e) => {
    // onChangeValue(e);
    setRange(e.target.value);
    setInputValue(e.target.value);
    rangeLinearGradient(e.target.value, min, max);
  };
  const handleChange2 = (max) => (e) => {
    // onChangeValue(e);
    // setRange(e.target.value);
    // setInputValue(e.target.value);
    // rangeLinearGradient(e.target.value, min, max);
    let newObj = { ...item, value: e.target.value };
    console.log('newObj', newObj);
    axios('/ezcon/api/ba/frontSetstate', {
      method: 'POST',
      headers: { authorization: window.localStorage['feathers-jwt'] },
      data: newObj,
    })
      .then((res) => {
        console.log('==Setstate OK', res);
      })
      .catch((error) => {
        console.error('==Setstate Error', error);
      });
  };

  const calculatePercentage = (value, min, max) => {
    return ((value - min) / (max - min)) * 100 + '%';
  };

  const rangeLinearGradient = (value, min, max) => {
    const percentage = calculatePercentage(value, min, max);
    const newBackgroundStyle = `linear-gradient(90deg, ${linearGradientColor} 0% ${percentage}, ${rangeBackgroundColor} ${percentage} 100%)`;
    rangeRef.current.style.background = newBackgroundStyle;
  };
  const getTextUI = (item) => {
    if (item && item.tableText) {
      const arr = item.tableText.split('\n').map((x) => <div>{x}</div>); // .join(<br />)
      return arr;
    } else {
      return <>無文字</>;
    }
  };

  return (
    <>
      <div className={styles.sliderContainer}>
        <div className={styles.itemText}>{getTextUI(item)}</div>
        <div className={styles.sliderRange}>{range}</div>
        {sync === 1 && (
          <>
            <input
              ref={rangeRef}
              className={styles.sliderInput}
              type="range"
              step={step}
              min={min}
              max={max}
              value={inputValue}
              onChange={handleChange(max)}
              onMouseUp={handleChange2(max)}
              onTouchEnd={handleChange2(max)}
            />
            <div className={styles.sliderRangeVal}>
              <div>{min}</div>
              <div>{max}</div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

Slider.propTypes = {
  step: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  defaultLength: PropTypes.number.isRequired,
  sliderThumbColor: PropTypes.string.isRequired,
  linearGradientColor: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  onChangeValue: PropTypes.func.isRequired,
};

export default Slider;
